module.exports = __webpack_public_path__ + "static/assets/58bf25731e172ab8ef0601bfdb074f08.svg";